/*
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { BufferAttribute } from 'three';
import { ChannelType, ColorMapType } from '../CrownDesc';
import { CrownShapeCapUtil } from './CrownShapeCapUtil';
import { ShaderAccessor } from './ShaderAccessor';
import { MaterialCache, PointsMaterialShape } from '@sick-davinci/glow';
import { CrownPointsMaterial, CrownPointsMaterialColorAttribute, CrownPoinsMaterialColorMode } from '../CrownPointsMaterial';
/**
 * Updates the shader buffers depending on the setColorMap function from ScanDecoration
 */
export class ShaderAccessorColorMap extends ShaderAccessor {
    constructor(echoIdx) {
        super(echoIdx);
        this._materialCache = new MaterialCache();
    }
    static getColorMapFromDeco(decoration, echoIdx) {
        let defaultColorMap;
        let scanColorMap;
        if (decoration.ColorMaps == null) {
            return null;
        }
        decoration.ColorMaps.forEach((element) => {
            if (element.Echo === 0) {
                defaultColorMap = element;
            }
            if (element.Echo !== echoIdx) {
                return;
            }
            scanColorMap = element;
        });
        if (scanColorMap == null) {
            scanColorMap = defaultColorMap;
        }
        return scanColorMap;
    }
    updateShader(geometry, decoration) {
        if (this._polarScan == null) {
            return;
        }
        const scanDecoGradient = ShaderAccessorColorMap.getColorMapFromDeco(decoration, this._echoIdx);
        if (scanDecoGradient == null) {
            return;
        }
        switch (scanDecoGradient.ChannelType) {
            case ChannelType.DISTANCE:
                const distvalues = this._polarScan.DistValues[this._echoIdx];
                const distView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(distvalues.data, distvalues.endian);
                geometry.addAttribute('preliminaryColor', new BufferAttribute(new Float32Array(distView.buffer, distView.byteOffset, distView.byteLength / 4), 1));
                break;
            case ChannelType.RSSI:
                const rssiValues = this._polarScan.RssiValues[this._echoIdx];
                const rssiView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(rssiValues.data, rssiValues.endian);
                geometry.addAttribute('preliminaryColor', new BufferAttribute(new Float32Array(rssiView.buffer, rssiView.byteOffset, rssiView.byteLength / 4), 1));
                break;
            case ChannelType.PHI:
                const phiArray = CrownShapeCapUtil.getPhiFloat32Array(this._polarScan.ChannelPhi, this._polarScan.DistValues[this._echoIdx].numOfElems);
                geometry.addAttribute('preliminaryColor', new BufferAttribute(phiArray, 1));
                break;
            case ChannelType.THETA:
                const thetaView = CrownShapeCapUtil.getArrayInCorrectByteOrder32(this._polarScan.ChannelTheta.data, this._polarScan.ChannelTheta.endian);
                geometry.addAttribute('preliminaryColor', new BufferAttribute(new Float32Array(thetaView.buffer, thetaView.byteOffset, thetaView.byteLength / 4), 1));
                break;
            default:
                return;
        }
        const colorMap = new Array(scanDecoGradient.ColorMap.ColorStops.length);
        scanDecoGradient.ColorMap.ColorStops.forEach((crownStop, index) => {
            colorMap[index] = {
                p: crownStop.Value,
                rgb: [crownStop.R / 255, crownStop.G / 255, crownStop.B / 255],
            };
        });
        this._shaderMaterial = this._materialCache.getMaterial(decoration, () => {
            return new CrownPointsMaterial({
                size: decoration.PointSize,
                sizeAttenuation: false,
                usePolarDataBuffers: true,
                pointsShape: PointsMaterialShape.circle,
                colorAttribute: CrownPointsMaterialColorAttribute.PRELIMARY_COLOR,
                interpolationMode: scanDecoGradient.ColorMap.ColorMapType === ColorMapType.DISCRETE ?
                    CrownPoinsMaterialColorMode.DISCRETE_INTERPOLATION : CrownPoinsMaterialColorMode.LINEAR_INTERPOLATION,
            }).setColorMap(colorMap, scanDecoGradient.ColorMap.RangeStart, scanDecoGradient.ColorMap.RangeStop);
        });
    }
}
//# sourceMappingURL=ShaderAccessorColorMap.js.map